import { render, staticRenderFns } from "./NameAdd.vue?vue&type=template&id=2b637858"
import script from "./NameAdd.vue?vue&type=script&lang=js"
export * from "./NameAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports